import type { RecentKeyword } from '@/shared/lib/storage/recentKeywords';
import type { RecentAsset } from '@/shared/types/recentAssets';

import type { SearchResult } from '@/entities/search';

import { SearchResultRecentSection } from '@/features/dataSearch/ui/SearchResultRecentSection';
import { SearchResultSuggestion } from '@/features/dataSearch/ui/SearchResultSuggestion';

import styles from './SearchResultDropdown.module.css';

type SearchResultDropdownProps = {
  recentAssets: RecentAsset[];
  recentKeywords: RecentKeyword[];
  isShowSearchSuggestions: boolean;
  debouncedValue?: string;
  onClickRecentAsset: (asset: RecentAsset) => void;
  onClickKeyword: (keyword: string) => void;
  onClickRemoveKeyword: (keyword: string) => void;
  onClickSuggestion: (suggestion: SearchResult) => void;
  onClickViewAllResults: () => void;
};

export const SearchResultDropdown = ({
  recentAssets,
  recentKeywords,
  isShowSearchSuggestions,
  debouncedValue = '',
  onClickRecentAsset,
  onClickKeyword,
  onClickRemoveKeyword,
  onClickSuggestion,
  onClickViewAllResults,
}: SearchResultDropdownProps) => {
  return (
    <div className={styles.dropdown}>
      {isShowSearchSuggestions ? (
        <SearchResultSuggestion
          debouncedValue={debouncedValue}
          onClickSuggestion={onClickSuggestion}
          onClickViewAllResults={onClickViewAllResults}
        />
      ) : (
        <SearchResultRecentSection
          recentAssets={recentAssets}
          recentKeywords={recentKeywords}
          onClickRecentAsset={onClickRecentAsset}
          onClickKeyword={onClickKeyword}
          onClickRemoveKeyword={onClickRemoveKeyword}
        />
      )}
    </div>
  );
};
